import classNames from 'classnames';

import { useTheme } from '../../../contexts/ThemeContext';
import Menu from '../../menus/Menu';

import coorsliteLogo from '../../../../img/coorslive/coorslight_logo.svg';
import normandinLogo from '../../../../img/coorslive/normandin_logo_tight.png';
import styles from '../../../../styles/themes/coorslive/footer-coorslive.module.css';

interface FooterCoorsliveProps {
    className?: string;
    menuItems?: MenuItem[];
}

const FooterCoorslive = ({ className = null, menuItems = null }: FooterCoorsliveProps) => {
    const { isVariant = () => false } = useTheme();
    const isNormandinVariant = isVariant('normandin');

    return (menuItems || []).length > 0 ? (
        <footer
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.content}>
                <Menu
                    items={menuItems}
                    itemActiveClassName={styles.itemActive}
                    itemsClassName={styles.items}
                    itemClassName={styles.item}
                    className={styles.menu}
                />

                <div className={styles.logos}>
                    {isNormandinVariant ? (
                        <img
                            className={classNames(styles.logo, styles.normandin)}
                            src={normandinLogo}
                        />
                    ) : null}
                    <img className={styles.logo} src={coorsliteLogo} />
                </div>
            </div>
        </footer>
    ) : null;
};

export default FooterCoorslive;
